import type { PriorAuthorizationInfoFragment } from '../../graphql/generated/graphql';
import type { BasicPrescriberOrderFragment } from '../cabinet/prescriber-orders';

import { isNewOrder } from './is-new-order';

export const hasPriorPrescriptions = (
    orders?: (BasicPrescriberOrderFragment | PriorAuthorizationInfoFragment)[]
) => !!orders?.some((order) => !isNewOrder(order));
